<template>
  <div style="width: 100vw">
    <div
      v-show="!loadingSync"
      class="nav_index_view"
      id="boxFixed"
      :class="{ is_fixed: isFixed }"
    >
      <div>
        <el-menu
          background-color="#003F79"
          active-text-color="#fff"
          text-color="#fff"
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
        >
          <el-menu-item
            v-for="(item, index) in webNavbarList"
            :key="index"
            :index="`${index}`"
          >{{ item.name }}
          </el-menu-item>
        </el-menu>
      </div>
    </div>
    <div
      v-show="isFixed && !loadingSync"
      style="width: 100%; height: 80px"
    ></div>
    <el-skeleton style="width: 100vw" :loading="loadingSync" animated>
      <template slot="template">
        <el-skeleton-item variant="p" style="width: 100vw; height: 80px"/>
        <div class="common_view">
          <el-skeleton-item
            variant="p"
            style="width: 1200px; height: 90px; margin-top: 10px"
          />
          <div class="wrapper_top">
            <el-skeleton-item variant="p" style="width: 464px; height: 90px"/>
            <el-skeleton-item
              variant="p"
              style="width: 362px; height: 90px; margin-left: 6px"
            />
            <el-skeleton-item
              variant="p"
              style="width: 362px; height: 90px; margin-left: 6px"
            />
          </div>
          <div class="wrapper_ul1">
            <div class="wrapper_ul_left">
              <el-skeleton-item
                variant="p"
                style="width: 464px; height: 290px"
              />
              <el-skeleton-item
                variant="p"
                style="width: 464px; height: 130px; margin-top: 6px"
              />
            </div>
            <div class="wrapper_ul_right">
              <el-skeleton-item
                variant="p"
                style="width: 362px; height: 214px"
              />
              <el-skeleton-item
                variant="p"
                style="width: 362px; height: 214px"
              />
              <el-skeleton-item
                variant="p"
                style="width: 362px; height: 214px"
              />
              <el-skeleton-item
                variant="p"
                style="width: 362px; height: 214px"
              />
            </div>
          </div>
          <div class="navWrapper">
            <div class="navBox">
              <el-skeleton-item
                variant="p"
                style="width: 100%; height: 54px; margin-top: 20px"
              />
              <div class="nCenter" style="justify-content: space-between">
                <div class="nCItem">
                  <el-skeleton-item
                    variant="p"
                    style="width: 286px; height: 215px"
                  />
                  <el-skeleton-item
                    variant="p"
                    style="width: 286px; height: 60px"
                  />
                  <div class="n_text">
                    <el-skeleton-item
                      variant="p"
                      style="width: 112px; height: 20px"
                    />
                    <el-skeleton-item
                      variant="p"
                      style="width: 34px; height: 20px"
                    />
                  </div>
                </div>
                <div class="nCItem">
                  <el-skeleton-item
                    variant="p"
                    style="width: 286px; height: 215px"
                  />
                  <el-skeleton-item
                    variant="p"
                    style="width: 286px; height: 60px"
                  />
                  <div class="n_text">
                    <el-skeleton-item
                      variant="p"
                      style="width: 112px; height: 20px"
                    />
                    <el-skeleton-item
                      variant="p"
                      style="width: 34px; height: 20px"
                    />
                  </div>
                </div>
                <div class="nCItem">
                  <el-skeleton-item
                    variant="p"
                    style="width: 286px; height: 215px"
                  />
                  <el-skeleton-item
                    variant="p"
                    style="width: 286px; height: 60px"
                  />
                  <div class="n_text">
                    <el-skeleton-item
                      variant="p"
                      style="width: 112px; height: 20px"
                    />
                    <el-skeleton-item
                      variant="p"
                      style="width: 34px; height: 20px"
                    />
                  </div>
                </div>
              </div>
              <div class="nCenter" style="justify-content: space-between">
                <div class="nCItem">
                  <el-skeleton-item
                    variant="p"
                    style="width: 286px; height: 215px"
                  />
                  <el-skeleton-item
                    variant="p"
                    style="width: 286px; height: 60px"
                  />
                  <div class="n_text">
                    <el-skeleton-item
                      variant="p"
                      style="width: 112px; height: 20px"
                    />
                    <el-skeleton-item
                      variant="p"
                      style="width: 34px; height: 20px"
                    />
                  </div>
                </div>
                <div class="nCItem">
                  <el-skeleton-item
                    variant="p"
                    style="width: 286px; height: 215px"
                  />
                  <el-skeleton-item
                    variant="p"
                    style="width: 286px; height: 60px"
                  />
                  <div class="n_text">
                    <el-skeleton-item
                      variant="p"
                      style="width: 112px; height: 20px"
                    />
                    <el-skeleton-item
                      variant="p"
                      style="width: 34px; height: 20px"
                    />
                  </div>
                </div>
                <div class="nCItem">
                  <el-skeleton-item
                    variant="p"
                    style="width: 286px; height: 215px"
                  />
                  <el-skeleton-item
                    variant="p"
                    style="width: 286px; height: 60px"
                  />
                  <div class="n_text">
                    <el-skeleton-item
                      variant="p"
                      style="width: 112px; height: 20px"
                    />
                    <el-skeleton-item
                      variant="p"
                      style="width: 34px; height: 20px"
                    />
                  </div>
                </div>
              </div>
              <div class="nCenter" style="justify-content: space-between">
                <div class="nCItem">
                  <el-skeleton-item
                    variant="p"
                    style="width: 286px; height: 215px"
                  />
                  <el-skeleton-item
                    variant="p"
                    style="width: 286px; height: 60px"
                  />
                  <div class="n_text">
                    <el-skeleton-item
                      variant="p"
                      style="width: 112px; height: 20px"
                    />
                    <el-skeleton-item
                      variant="p"
                      style="width: 34px; height: 20px"
                    />
                  </div>
                </div>
                <div class="nCItem">
                  <el-skeleton-item
                    variant="p"
                    style="width: 286px; height: 215px"
                  />
                  <el-skeleton-item
                    variant="p"
                    style="width: 286px; height: 60px"
                  />
                  <div class="n_text">
                    <el-skeleton-item
                      variant="p"
                      style="width: 112px; height: 20px"
                    />
                    <el-skeleton-item
                      variant="p"
                      style="width: 34px; height: 20px"
                    />
                  </div>
                </div>
                <div class="nCItem">
                  <el-skeleton-item
                    variant="p"
                    style="width: 286px; height: 215px"
                  />
                  <el-skeleton-item
                    variant="p"
                    style="width: 286px; height: 60px"
                  />
                  <div class="n_text">
                    <el-skeleton-item
                      variant="p"
                      style="width: 112px; height: 20px"
                    />
                    <el-skeleton-item
                      variant="p"
                      style="width: 34px; height: 20px"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="wrapper_right">
              <el-skeleton-item
                variant="p"
                style="width: 280px; height: 180px; margin-top: 20px"
              />
              <el-skeleton-item
                variant="p"
                style="width: 280px; height: 442px; margin-top: 20px"
              />
              <el-skeleton-item
                variant="p"
                style="width: 280px; height: 258px; margin-top: 20px"
              />
              <el-skeleton-item
                variant="p"
                style="width: 280px; height: 141px; margin-top: 20px"
              />
            </div>
          </div>
          <!-- <div style="display: flex; align-items: center; justify-items: space-between;">
            <el-skeleton-item variant="text" style="margin-right: 16px;" />
            <el-skeleton-item variant="text" style="width: 30%;" />
          </div> -->
        </div>
      </template>
      <template>
        <article>
          <!--          <Recommend ref="RecommendSync" v-show="activeIndex == 0"></Recommend>-->
          <div v-show="activeIndex == 0">
            <div v-if="msg.photoUrl" @click="goLink('msg')">
              <a
                class="wrapper_con"
                :href="msg.internalLink || msg.outsideLink"
                @click.prevent="goProducts"
              >
                <div class="wrapper_flex">
                  <img class="one_image" :src="msg.photoUrl" alt=""/>
                  <div class="tow_view">广告</div>
                </div>
              </a>
            </div>

            <div
              class="wrapper_top"
              v-if="msg1.photoUrl || msg2.photoUrl || msg3.photoUrl"
            >
              <div @click="goLink('msg1')">
                <a
                  :href="msg1.outsideLink || msg1.internalLink"
                  @click.prevent="goProducts"
                >
                  <div class="wrapper_item" style="width: 464px">
                    <img v-if="msg1.photoUrl" :src="msg1.photoUrl" alt=""/>
                    <div v-if="msg1.photoUrl" class="tow_view">广告</div>
                  </div>
                </a>
              </div>

              <div @click="goLink('msg2')">
                <a
                  :href="msg2.outsideLink || msg2.internalLink"
                  @click.prevent="goProducts"
                >
                  <div class="wrapper_item" style="margin-left: 6px">
                    <img v-if="msg2.photoUrl" :src="msg2.photoUrl" alt=""/>
                    <div v-if="msg2.photoUrl" class="tow_view">广告</div>
                  </div>
                </a>
              </div>

              <div @click="goLink('msg3')">
                <a
                  :href="msg3.outsideLink || msg3.internalLink"
                  @click.prevent="goProducts"
                >
                  <div class="wrapper_item" style="margin-left: 6px">
                    <img v-if="msg3.photoUrl" :src="msg3.photoUrl" alt=""/>
                    <div v-if="msg3.photoUrl" class="tow_view">广告</div>
                  </div>
                </a>
              </div>
            </div>
            <!--            广告组建-->
            <div class="wrapper_ul_gua">
              <div class="left">
                <a
                  :href="'https://www.cv2000.cn/info?uid=' + oneObj.uid"
                  @click.prevent="goProducts"
                >
                  <div
                    class="left_vue"
                    v-if="slideList"
                    style="height: 290px"
                    @click="goToInfo(oneObj)"
                  >
                    <img
                      v-if="oneObj"
                      :src="oneObj.photoList[0]"
                      :alt="oneObj.title"
                    />
                    <div class="carousel-title" @click="goToInfo(oneObj)">
                      <span>{{ oneObj.title }}</span>
                    </div>
                  </div>
                </a>
                <a
                  :href="'https://www.cv2000.cn/info?uid=' + oneTow.uid"
                  @click.prevent="goProducts"
                >
                  <div class="left_ul" @click="goToInfo(oneTow)">
                    <div class="title">{{ oneTow.title }}</div>
                    <div class="text">{{ oneTow.summary }}</div>
                  </div>
                </a>
              </div>
              <div class="right">
                <div
                  @click="goToInfo(item)"
                  v-for="(item, index) in slideList"
                  :key="index"
                >
                  <a
                    :href="'https://www.cv2000.cn/info?uid=' + item.uid"
                    @click.prevent="goProducts"
                  >
                    <img
                      v-if="slideList.length > 0"
                      :src="item.photoList[0]"
                      alt=""
                    />
                    <div class="text">{{ item.title }}</div>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <!--          广告组建-->

          <div class="blank" v-show="activeIndex == 0"></div>
          <!-- <pre>{{ lista }}{{ webNavbarList }}</pre> -->
          <div class="navWrapper" v-show="activeIndex == 0">
            <div class="navBox">
              <div
                class="navList"
                v-for="(item, index) in navList"
                :key="index"
              >
                <div class="nTitle">
                  <div>
                    <div>
                      <img src="/static/images/tips.png" alt=""/>
                    </div>
                    <div v-if="item.name">{{ item.name }}</div>
                  </div>
                  <div style="cursor: pointer" @click="hand(item, index + 1)">
                    更多>>
                  </div>
                </div>
                <ul class="nCenter">
                  <li
                    class="nCItem"
                    v-for="(ite, ind) in item.children"
                    :key="ind"
                    @click="goToInfo(ite)"
                  >
                    <a
                      :href="'https://www.cv2000.cn/info?uid=' + ite.uid"
                      @click.prevent="goProducts"
                    >
                      <div class="nDivView">
                        <img class="nImage" :src="ite.photoUrl" alt=""/>
                      </div>
                      <div>
                        <div class="n_title">{{ ite.title }}</div>
                        <div class="n_text">
                          <span>{{ ite.author }}</span>
                          <span>{{ timeAgo(ite.publishTime) }}</span>
                        </div>
                      </div>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="wrapper_right">
              <!-- 二级广告 -->
              <SecondRecommend></SecondRecommend>
              <!-- 热门文章 -->
              <PopularArticles
                v-if="secondData.length > 0"
                :secondData="secondData"
              ></PopularArticles>
              <!-- 热门专题 -->
              <PopularTopics></PopularTopics>
              <!-- 友情链接 -->
              <FriendlyLinks></FriendlyLinks>
            </div>
          </div>

          <div class="blank"></div>
          <div class="wrapper_info">
            <div class="wrapper_left">
              <div v-for="(item, index) in newBlogData" :key="index">
                <Content :item="item"></Content>
              </div>
              <div class="wrapper_img" v-if="newBlogData.length == 0">
                <img src="/static/images/home/null.png" alt=""/>
                <div style="margin-top: 30px">暂无相关内容</div>
                <div>先去其他频道看看吧</div>
              </div>
              <div
                class="wrapper_bottom_text"
                v-if="total == newBlogData.length && newBlogData.length > 0"
              >
                已展示全部内容
              </div>
              <div class="isEnd">
                <div
                  class="loadContent"
                  @click="loadContent"
                  v-if="total != newBlogData.length"
                >
                  点击加载更多
                </div>
                <div class="lds-css ng-scope" v-if="!isEnd && loading">
                  <div style="width: 100%; height: 100%" class="lds-facebook">
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
                <!-- <span v-if="isEnd">我也是有底线的~</span> -->
              </div>
            </div>
            <div class="wrapper_right">
              <template v-if="activeIndex != 0">
                <!-- 二级广告 -->
                <SecondRecommend></SecondRecommend>
                <!-- 热门文章 -->
                <PopularArticles
                  v-if="secondData.length > 0"
                  :secondData="secondData"
                ></PopularArticles>
                <!-- 热门专题 -->
                <PopularTopics></PopularTopics>
                <!-- 友情链接 -->
                <FriendlyLinks></FriendlyLinks>
              </template>
            </div>
          </div>
        </article>
      </template>
    </el-skeleton>

    <div class="wrapper_bottom">
      <div class="flex_column_center">
        <div class="flex_center">
          <div class="wrapper_content flex_center">
            <a @click="onClickHome">
              <img class="logo" src="/static/images/home/logo.png" alt=""/>
            </a>
          </div>
          <div class="solid"></div>

          <div
            class="wrapper_content flex_column_center"
            @mouseleave="onClickMouseleave"
            @mouseenter="onClickMouseenter"
          >
            <img
              style="width: 204px; height: 86px"
              src="/static/images/home/data.png"
              alt=""
            />
            <div class="wrapper_content_image" v-show="mouseActive">
              <img src="/static/images/home/Bigdata.png" alt=""/>
            </div>
          </div>
          <div class="solid"></div>
          <div
            class="wrapper_content flex_column_center"
            @mouseleave="onClickMouseMall"
            @mouseenter="onClickMouseenterMall"
          >
            <img class="syLogo" src="/static/images/home/mall.png" alt=""/>
            <div class="sy_title">全国商用车公共交易平台</div>
            <div class="wrapper_content_image" v-show="mallActive">
              <img src="/static/images/home/mallH5.png" alt=""/>
            </div>
          </div>
        </div>
        <div class="wrapper_view_bottom flex_center">
          <div @click="onClickAbout" style="cursor: pointer" class="title">关于我们</div>
          <div class="solid_view"></div>
          <div class="title">法律声明</div>
          <div class="solid_view"></div>
          <div class="title">服务协议</div>
          <div class="solid_view"></div>
          <div class="title">
            <a href="https://beian.miit.gov.cn" target="_blank">
              {{ contact.recordNum }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getWebConfig} from '@/api/index'
import Recommend from '../components/Recommend'
import Content from '../components/Content'
import SecondRecommend from '../components/SecondRecommend'
import PopularArticles from '../components/PopularArticles'
import PopularTopics from '../components/PopularTopics'
import FriendlyLinks from '../components/FriendlyLinks'
import {advertClick, advertGetListByLevel, getWebNavbar} from '../api/index'
import {setCookie} from '@/utils/cookieUtils'
import {
  getBlogByLevel,
  getNewBlog,
  recorderVisitPage,
  getRedirect,
} from '../api/index'
import {Loading} from 'element-ui'
import {getArticleByBlogSortUid} from '../api/classify'
import {getBlogByUid} from '../api/blogContent'
import {timeAgo} from '../utils/webUtils'

export default {
  name: 'index',
  components: {
    //注册组件
    Recommend,
    SecondRecommend,
    PopularArticles,
    PopularTopics,
    FriendlyLinks,
    Content,
  },
  data () {
    return {
      loadingSync: false,
      mouseActive: false,
      mallActive: false,
      isFixed: false,
      offsetTop: 0,
      activeIndex: '0',
      loadingInstance: null, // loading对象
      VUE_MOGU_WEB: process.env.VUE_MOGU_WEB,
      firstData: [], //；一级推荐数据
      secondData: [], //；二级级推荐数据
      thirdData: [], //三级推荐
      fourthData: [], //四级推荐
      newBlogData: [{}], //最新文章
      hotBlogData: [], //最热文章
      hotTagData: [], //最新标签
      keyword: '',
      currentPage: 1,
      pageSize: 15,
      total: 0, //总数量
      isEnd: false, //是否到底底部了
      loading: false, //是否正在加载
      webNavbarList: [], // 顶部nav
      selectBlogUid: '',
      navList: [],
      contact: {},

      slideList: [],
      oneObj: {},
      oneTow: {},
      msg: {},
      msg1: {},
      msg2: {},
      msg3: {},
    }
  },
  async mounted () {
    // 注册scroll事件并监听
    this.loading = false

    await this.getWebNavbarList() // 获取顶部nav
    await this.getConfig()
    // 是否排序
    var secondParams = new URLSearchParams()
    secondParams.append('level', 2)
    secondParams.append('useSort', 1)
    var response = await getBlogByLevel(secondParams)
    if (response.code == this.$ECode.SUCCESS) {
      this.secondData = response.data.records
    }

    // 获取最新博客
    this.selectBlogUid = this.$route.query.catUid
    if (this.selectBlogUid) {
      await this.getBlogList(this.selectBlogUid)
      this.activeIndex = this.$route.query.catindex
    } else {
      await this.newBlogList()
    }

    // await this.$refs.RecommendSync.getinfo()
    this.loadingSync = false
    // var params = new URLSearchParams();
    // params.append("pageName", "INDEX");
    // recorderVisitPage(params).then(response => {
    // });
  },
  async created () {
    this.getinfo()
    if (this.isMobile() != null) {
      window.open('https://m.cv2000.cn/#/', '_self')
      return
    }
    let href = window.location.href
    console.log(href)
    let aid = ''
    const aidIndex = href.indexOf('?aid=')
    if (aidIndex !== -1) {
      const aidSubstring = href.substring(aidIndex + 5) // 5 是 "?aid=" 的长度
      const endIndex = aidSubstring.indexOf('#/')
      aid = aidSubstring.substring(0, endIndex)
      const r = await getRedirect({aid: this.$route.query.aid})
      if (r.code == 'error') return (location.href = 'https://www.cv2000.cn/404')
      location.href = 'https://www.cv2000.cn/info?uid=' + r.data
      return
    }
    window.addEventListener('scroll', this.initHeight)
    this.$nextTick(() => {
      this.offsetTop = document.querySelector('#boxFixed').offsetTop
    })
  },
  methods: {
    onClickAbout () {
      let routeData = this.$router.resolve({
        path: '/aboutUs',
        query: {}
      })
      window.open(routeData.href, '_blank')
    },
    goProducts () {
      return
    },
    async goLink (data) {
      var params = new URLSearchParams()
      params.append('uid', this[`${data}`].uid)
      const res = await advertClick(params)
      if (!this[`${data}`].internalLink && !this[`${data}`].outsideLink) return
      let url
      if (this[`${data}`].internalLink) {
        url = this[`${data}`].internalLink
      } else {
        url = this[`${data}`].outsideLink
      }
      window.open(url, '_blank')
    },
    async getinfo () {
      var params = new URLSearchParams()
      params.append('level', 1)
      params.append('useSort', 1)
      var response = await getBlogByLevel(params)
      if (response.code == this.$ECode.SUCCESS) {
        this.oneObj = response.data.records.splice(0, 1)[0]
        this.oneTow = response.data.records.splice(0, 1)[0]
        this.slideList = response.data.records
        if (this.slideList.length > 4) {
          this.slideList.length = 4
        }
      }
      await this.navMsg()
    },

    async navMsg () {
      var params = new URLSearchParams()
      params.append('level', 1)
      params.append('size', 1)
      var response = await advertGetListByLevel(params)
      if (response.code == this.$ECode.SUCCESS) {
        if (response.data.length == 0) return
        this.msg = response.data[0]
      }
      // 左
      var params1 = new URLSearchParams()
      params1.append('level', 4)
      params1.append('size', 1)
      var response1 = await advertGetListByLevel(params1)
      if (response1.code == this.$ECode.SUCCESS) {
        if (response1.data.length != 0) {
          this.msg1 = response1.data[0]
        }
      }
      // 中
      var params2 = new URLSearchParams()
      params2.append('level', 5)
      params2.append('size', 1)
      var response2 = await advertGetListByLevel(params2)
      if (response2.code == this.$ECode.SUCCESS) {
        if (response2.data.length != 0) {
          this.msg2 = response2.data[0]
        }
      }
      // 右
      var params3 = new URLSearchParams()
      params3.append('level', 6)
      params3.append('size', 1)
      var response3 = await advertGetListByLevel(params3)
      if (response3.code == this.$ECode.SUCCESS) {
        if (response3.data.length != 0) {
          this.msg3 = response3.data[0]
        }
      }
    },
    async getConfig () {
      const response = await getWebConfig()
      if (response.code == this.$ECode.SUCCESS) {
        this.contact = response.data
      }
    },
    isMobile () {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      console.log(flag)
      console.log('型号')
      return flag
    },
    initHeight () {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      this.isFixed = scrollTop > 120 ? true : false
    },

    timeAgo (dateTimeStamp) {
      return timeAgo(dateTimeStamp)
    },
    //跳转到搜索详情页
    goToList (uid) {
      let routeData = this.$router.push({
        path: '/list',
        query: {sortUid: uid},
      })
    },

    onClickMouseMall () {
      this.mallActive = false
    },
    onClickMouseenterMall () {
      this.mallActive = true
    },
    onClickMouseleave () {
      this.mouseActive = false
    },

    onClickMouseenter () {
      this.mouseActive = true
    },
    onClickHome () {
      // this.$router.replace("/")
    },

    async getBlogListSync (uid, name, index) {
      console.log(uid, name, index)
      var params = new URLSearchParams()
      params.append('sortUid', uid)
      params.append('currentPage', 1)
      params.append('pageSize', 6)
      params.append('source', 'index')
      const res = await getArticleByBlogSortUid(params)
      let list = JSON.parse(JSON.stringify(this.navList))
      list[index] = {
        name: name,
        catUid: uid,
        children: res.data.records,
      }
      this.navList = list
      this.$forceUpdate()
      console.log(this.navList)
    },
    // 获取导航栏列表
    async getWebNavbarList () {
      let params = {}
      params.isShow = 1
      let num = -1
      var response = await getWebNavbar(params)
      if (response.code == this.$ECode.SUCCESS) {
        let webNavbarList = response.data
        let newWebNavbarList = []
        webNavbarList.forEach(async (item, index) => {
          if (item.isShow == 1) {
            newWebNavbarList.push(item)
            if (item.catUid) {
              num = num + 1
              await this.getBlogListSync(item.catUid, item.summary, num)
            }
          }
        })
        this.webNavbarList = newWebNavbarList
        setCookie('webNavbarList', JSON.stringify(webNavbarList), 1)
      }
    },

    //跳转到搜索详情页
    goToAuthor (author) {
      let routeData = this.$router.push({
        path: '/list',
        query: {author: author},
      })
    },

    //最新博客列表
    async newBlogList () {
      var that = this
      var params = new URLSearchParams()
      params.append('currentPage', this.currentPage)
      params.append('pageSize', this.pageSize)
      var response = await getNewBlog(params)
      if (response.code == this.$ECode.SUCCESS) {
        that.newBlogData = response.data.records
        that.total = response.data.total
        that.pageSize = response.data.size
        that.currentPage = response.data.current
      }
      // that.loadingInstance.close();
    },

    loadContent: function () {
      var that = this
      that.loading = false
      this.selectBlogUid = this.$route.query.catUid
      that.currentPage = that.currentPage + 1
      if (this.selectBlogUid) {
        var params = new URLSearchParams()
        params.append('sortUid', this.selectBlogUid)
        params.append('currentPage', that.currentPage)
        params.append('pageSize', that.pageSize)
        getArticleByBlogSortUid(params).then((response) => {
          if (
            response.code == this.$ECode.SUCCESS &&
            response.data.records.length > 0
          ) {
            that.isEnd = false
            var newData = that.newBlogData.concat(response.data.records)
            this.newBlogData = newData
            this.currentPage = response.data.current
            this.pageSize = response.data.size
            that.total = response.data.total
            if (newData.length < that.pageSize) {
              that.isEnd = true
            }
          } else {
            that.isEnd = true
          }
          that.loading = false
        })
      } else {
        var params = new URLSearchParams()
        params.append('currentPage', that.currentPage)
        params.append('pageSize', that.pageSize)
        getNewBlog(params).then((response) => {
          if (
            response.code == this.$ECode.SUCCESS &&
            response.data.records.length > 0
          ) {
            that.isEnd = false
            var newData = that.newBlogData.concat(response.data.records)
            that.newBlogData = newData
            that.total = response.data.total
            that.pageSize = response.data.size
            that.currentPage = response.data.current

            //全部加载完毕
            if (newData.length < that.pageSize) {
              that.isEnd = true
            }
          } else {
            that.isEnd = true
          }
          that.loading = false
        })
      }
    },
    goToInfo (blog) {
      if (blog.type == '0') {
        let routeData = this.$router.resolve({
          path: '/info',
          query: {uid: blog.uid},
        })
        window.open(routeData.href, '_blank')
      } else if (blog.type == '1') {
        var params = new URLSearchParams()
        params.append('uid', blog.uid)
        getBlogByUid(params).then((response) => {
          // 记录一下用户点击日志
        })
        window.open(blog.outsideLink, '_blank')
      }
    },
    handleSelect (event) {
      this.currentPage = 1
      let data = this.webNavbarList[event]
      this.activeIndex = event
      this.isEnd = false
      switch (data.name) {
        case '专题':
          this.$router.replace('/specialSubject')
          break
        case '精选':
          this.$router.replace('/')
          this.newBlogList()
          break
        default:
          this.$router.replace({
            path: '/',
            query: {catUid: data.catUid, catindex: event},
          })
          this.getBlogList(data.catUid)
      }
    },
    hand (data, event) {
      this.activeIndex = event
      this.$router.replace({
        path: '/',
        query: {catUid: data.catUid, catindex: event},
      })
      this.getBlogList(data.catUid)
      window.scrollTo(0, 0)
    },
    getBlogList (blogSortUid) {
      this.selectBlogUid = blogSortUid
      var params = new URLSearchParams()
      if (blogSortUid) {
        params.append('sortUid', blogSortUid)
      }
      params.append('currentPage', this.currentPage)
      params.append('pageSize', this.pageSize)
      getArticleByBlogSortUid(params).then((response) => {
        if (response.code == this.$ECode.SUCCESS) {
          this.newBlogData = response.data.records
          this.currentPage = response.data.current
          this.pageSize = response.data.size
          this.total = response.data.total
          console.log(this.total)
          console.log(this.newBlogData.length)
        }
      })
    },
  },
}
</script>

<style scoped>
.el-loading-mask {
  z-index: 2002;
}

.isEnd {
  float: left;
  width: 100%;
  height: 80px;
  text-align: center;
}

.ng-scope {
  margin: 0 auto;
  width: 18%;
  height: 10%;
}

.loadContent {
  width: 120px;
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  margin: 0 auto;
  color: aliceblue;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.8);
}

@keyframes lds-facebook_1 {
  0% {
    top: 0px;
    height: 200px;
  }

  50% {
    top: 80px;
    height: 40px;
  }

  100% {
    top: 80px;
    height: 40px;
  }
}

@-webkit-keyframes lds-facebook_1 {
  0% {
    top: 0px;
    height: 200px;
  }

  50% {
    top: 80px;
    height: 40px;
  }

  100% {
    top: 80px;
    height: 40px;
  }
}

@keyframes lds-facebook_2 {
  0% {
    top: 20px;
    height: 160px;
  }

  50% {
    top: 80px;
    height: 40px;
  }

  100% {
    top: 80px;
    height: 40px;
  }
}

@-webkit-keyframes lds-facebook_2 {
  0% {
    top: 20px;
    height: 160px;
  }

  50% {
    top: 80px;
    height: 40px;
  }

  100% {
    top: 80px;
    height: 40px;
  }
}

@keyframes lds-facebook_3 {
  0% {
    top: 40px;
    height: 120px;
  }

  50% {
    top: 80px;
    height: 40px;
  }

  100% {
    top: 80px;
    height: 40px;
  }
}

@-webkit-keyframes lds-facebook_3 {
  0% {
    top: 40px;
    height: 120px;
  }

  50% {
    top: 80px;
    height: 40px;
  }

  100% {
    top: 80px;
    height: 40px;
  }
}

.lds-facebook {
  position: relative;
}

.lds-facebook div {
  position: absolute;
  width: 20px;
}

.lds-facebook div:nth-child(1) {
  left: 40px;
  background: #1d0e0b;
  -webkit-animation: lds-facebook_1 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  animation: lds-facebook_1 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  -webkit-animation-delay: -0.2s;
  animation-delay: -0.2s;
}

.lds-facebook div:nth-child(2) {
  left: 90px;
  background: #774023;
  -webkit-animation: lds-facebook_2 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  animation: lds-facebook_2 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  -webkit-animation-delay: -0.1s;
  animation-delay: -0.1s;
}

.lds-facebook div:nth-child(3) {
  left: 140px;
  background: #d88c51;
  -webkit-animation: lds-facebook_3 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  animation: lds-facebook_3 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
}

.lds-facebook {
  width: 90px !important;
  height: 90px !important;
  -webkit-transform: translate(-45px, -45px) scale(0.45) translate(45px, 45px);
  transform: translate(-45px, -45px) scale(0.45) translate(45px, 45px);
}

.iconfont {
  font-size: 15px;
  margin-right: 2px;
}

.nav_index_view {
  width: 100%;
  min-width: 1200px;
  height: 80px;
  background: #003f79;
  /* margin-top: 112px; */
}

.nav_index_view > div {
  width: 1200px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
}

article {
  margin: 12px auto;
}

.el-menu.el-menu--horizontal {
  border: none;
}

.el-menu-item {
  font-size: 20px;
}

.is-active {
  font-weight: bold;
}

.blank {
  height: 30px;
}

.wrapper_info {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.wrapper_left {
  flex: 1;
}

.wrapper_bottom {
  width: 100%;
  height: 220px;
  background: #ffffff;
}

.wrapper_bottom > div {
  width: 1200px;
  height: 100%;
  margin: 0 auto;
}

.wrapper_content {
  position: relative;
  /* width: 204px; */
  height: 90px;
  cursor: pointer;
}

.wrapper_content > .logo {
  width: 204px;
  height: 78px;
}

.wrapper_content_image {
  position: absolute;
  width: 158px;
  height: 158px;
  bottom: 100px;
}

.wrapper_content_image img {
  width: 100%;
  height: 100%;
}

.wrapper_bottom .solid {
  width: 1px;
  height: 64px;
  border-right: 2px solid #cecece;
  margin: 0 60px;
}

.wrapper_right {
  width: 280px;
  margin-left: 26px;
}

.syLogo {
  width: 62px;
  height: 62px;
}

.sy_title {
  font-size: 14px;
  color: #333333;
  margin-top: 4px;
}

.wrapper_view_bottom {
  width: 732px;
  height: 50px;
  border-top: 1px solid #cecece;
  border-bottom: 1px solid #cecece;
  margin-top: 20px;
}

.wrapper_view_bottom > .title {
  font-size: 16px;
  color: #333333;
  margin: 0 30px;
}

.wrapper_view_bottom > .solid_view {
  width: 1px;
  height: 26px;
  border-left: 2px solid #cecece;
}

.wrapper_bottom_text {
  text-align: center;
  margin-top: 20px;
  font-size: 16px;
}

.wrapper_img {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.wrapper_img > img {
  width: 306px;
  height: 266px;
}

.wrapper_img > div {
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: #666666;
  line-height: 37px;
}

.flex_between {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.flex_column {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.flex_center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.flex_column_center {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.flex {
  display: flex;
  align-items: center;
}

.navWrapper {
  display: flex;
}

.navBox {
  width: 894px;
}

.nTitle {
  display: flex;
  justify-content: space-between;
  height: 54px;
  font-size: 20px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  align-items: flex-end;
  margin-top: 20px;
  padding-bottom: 14px;
  border-bottom: 1px solid rgba(233, 155, 0, 0.85);
}

.nTitle > div:nth-of-type(1) {
  display: flex;
  align-items: center;
  font-size: 38px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #e99b00;
}

.common_view {
  width: 1200px;
  margin: 0 auto;
}

.nTitle > div:nth-of-type(1) img {
  width: 10px;
  height: 41px;
  margin-right: 12px;
}

.nCenter {
  display: flex;
  flex-wrap: wrap;
}

.nCItem {
  width: 286px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #666666;
}

.nCenter img {
  width: 286px;
  /* height: 215px; */
}

.nCenter > li:nth-of-type(2),
.nCenter > li:nth-of-type(5) {
  margin: 0 18px;
}

.nCenter > li {
  margin-bottom: 6px;
}

.nCItem > div:nth-of-type(1) {
  font-size: 24px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
  margin: 20px 0 16px 0;
}

.is_fixed {
  position: fixed;
  top: 0;
  left: 0;
  margin: 0 !important;
  z-index: 999;
}

.nDivView {
  width: 286px;
  height: 215px;
  overflow: hidden;
  cursor: pointer;
}

.nDivView :hover {
  transform: scale(1.1);
}

.nImage {
  width: 286px;
  /* height: 214px; */
  -webkit-transition: all 0.6s ease;
  -moz-transition: all 0.6s ease;
  -o-transition: all 0.6s ease;
  transition: all 0.6s ease;
}

.n_title {
  font-size: 20px;
  height: 60px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  color: #333333;
  overflow: hidden;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}

.n_text {
  font-size: 14px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  color: #666666;
  margin-top: 10px;
}

.navList:first-child {
  margin-top: -20px;
}

.wrapper_top {
  width: 1200px;
  height: 90px;
  margin-top: 8px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}

.wrapper_ul1 {
  width: 1200px;
  overflow: hidden;
  margin-top: 12px;
  display: flex;
}

.wrapper_ul_left {
  width: 464px;
  height: 434px;
}

.wrapper_ul_right {
  flex: 1;
  height: 434px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  box-sizing: border-box;
  padding-left: 6px;
}

.wrapper_top {
  width: 100%;
  height: 90px;
  margin-top: 8px;
  display: grid;
  /* grid-gap: 10px; */
  grid-template-columns: repeat(3, 1fr);
}

.wrapper_item {
  width: 362px;
  height: 90px;
  position: relative;
  overflow: hidden;
}

.wrapper_item:hover img {
  transform: scale(1.1);
}

.wrapper_item > img {
  width: 100%;
  min-height: 100%;
  -webkit-transition: all 0.6s ease;
  -moz-transition: all 0.6s ease;
  -o-transition: all 0.6s ease;
  transition: all 0.6s ease;
}

.one_image {
  width: 100%;
  /* height: 168px; */
  -webkit-transition: all 0.6s ease;
  -moz-transition: all 0.6s ease;
  -o-transition: all 0.6s ease;
  transition: all 0.6s ease;
}

.wrapper_ul_gua {
  width: 100%;
  margin-top: 12px;
  display: flex;
}

.wrapper_ul_gua > .left {
  width: 464px;
  height: 100%;
}

.wrapper_ul_gua > .right {
  flex: 1;
  height: 434px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  box-sizing: border-box;
  padding-left: 6px;
}

.wrapper_ul_gua > .right > div {
  width: 362px;
  height: 214px;
  cursor: pointer;
  position: relative;
  margin-bottom: 6px;
  overflow: hidden;
}

.wrapper_ul_gua > .right :hover img {
  transform: scale(1.1);
}

.wrapper_ul_gua > .right img {
  width: 362px;
  /* height: 214px; */
  min-height: 214px;
  -webkit-transition: all 0.6s ease;
  -moz-transition: all 0.6s ease;
  -o-transition: all 0.6s ease;
  transition: all 0.6s ease;
}

.wrapper_ul_gua > .right .text {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 40px;
  background: linear-gradient(180deg, rgba(238, 238, 238, 0) 0%, #1a1a1a 160%);
  text-align: center;
  line-height: 40px;
  font-size: 18px;
  font-weight: 500;
  color: #ffffff;
  padding: 0 20px;
  box-sizing: border-box;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.bannerBox {
  height: 290px;
}

.carousel-title {
  cursor: pointer;
  position: absolute;
  z-index: 10;
  bottom: 0px;
  height: 40px;
  width: 100%;
  line-height: 40px;
  text-align: center;
  background: linear-gradient(180deg, rgba(238, 238, 238, 0) 0%, #1a1a1a 160%);
  font-size: 18px;
  font-weight: 600;
  color: #ffffff;
  padding: 0 20px;
  box-sizing: border-box;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.left_ul {
  width: 100%;
  height: 138px;
  background: #003f79;
  margin-top: 6px;
  box-sizing: border-box;
  padding: 16px 20px;
}

.left_ul > .title {
  font-size: 20px;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 12px;
  cursor: pointer;
}

.left_ul > .text {
  width: 408px;
  /* height: 60px; */
  font-size: 14px;
  color: #ffffff;
  line-height: 20px;
  overflow: hidden;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  cursor: pointer;
}

.left_vue {
  position: relative;
  overflow: hidden;
}

.left_vue > img {
  width: 100%;
  /* height: 100%; */
  display: block;
  cursor: pointer;
  -webkit-transition: all 0.6s ease;
  -moz-transition: all 0.6s ease;
  -o-transition: all 0.6s ease;
  transition: all 0.6s ease;
}

.left :hover img {
  transform: scale(1.1);
}

.wrapper_con :hover .one_image {
  transform: scale(1.1);
}

.wrapper_flex {
  width: 100%;
  height: 90px;
  position: relative;
  overflow: hidden;
}

.tow_view {
  position: absolute;
  right: 8px;
  bottom: 8px;
  width: 54px;
  height: 24px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 4px;
  text-align: center;
  line-height: 24px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.82);
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue